import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

let option: any = {
  rtl: true,
  theme: {
    dark: false,
    options: { customProperties: true },
    themes: {
      dark: {
        primary: '#158E8D',
        accent: '#FF4081',
        secondary: '#ffe18d',
        success: '#4CAF50',
        info: '#416695',
        warning: '#FB8C00',
        err: '#FF5252',
        sidebar: '#faf9f4',
        outlinedark: '#212529',
      },
      light: {
        primary: '#158E8D',
        accent: '#e91e63',
        secondary: '#30b1dc',
        success: '#4CAF50',
        info: '#416695',
        warning: '#FB8C00',
        err: '#FF5252',
        sidebar: '#faf9f4',
        outlinedark: '#212529',
      },
    },
  },
  icons: {
    iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
};

export default new Vuetify(option);

// Vue.use(Vuetify, {
//   theme: {
//     primary: '#1976D2',
//     secondary: '#424242',
//     accent: '#82B1FF',
//     error: '#FF5252',
//     info: '#2196F3',
//     success: '#4CAF50',
//   },
// });

// Vue.use(Vuetify)

// const opts = {}

// export default new Vuetify(opts)
